export const config = {
  duration: 980,
  // Ease out func formula
  easing: (x) => Math.sin((x * Math.PI) / 2),
} as const

export const COORDINATES = {
  circle: {
    from: { rotateZ: 0 },
    to: [{ rotateZ: 75 }, { rotateZ: 150 }, { rotateZ: 0 }],
  },
  text: {
    from: { num: 3 },
    to: [
      {
        num: 2,
      },
      {
        num: 0,
      },
      {
        num: 3,
      },
    ],
  },
  planet: {
    m: {
      from: { scale: 1, left: '77px', bottom: '-3px' },
      to: [
        { scale: 2.2, bottom: '10px', left: '40px' },
        { scale: 1, bottom: '25px', left: '-5px' },
        { scale: 1, bottom: '-3px', left: '77px' },
      ],
    },
    l: {
      from: { scale: 1, left: '127px', bottom: '-5px' },
      to: [
        { scale: 2.2, bottom: '5px', left: '60px' },
        { scale: 1, bottom: '20px', left: '0px' },
        { scale: 1, bottom: '-5px', left: '127px' },
      ],
    },
  },
  transparentPlanet: {
    m: {
      from: { scale: 1, left: '11px', bottom: '55px' },
      to: [
        { scale: 0.8, left: '18px', bottom: '88px' },
        { scale: 2.3, left: '55px', bottom: '105px' },
        { scale: 1, left: '11px', bottom: '55px' },
      ],
    },
    l: {
      from: { scale: 1, left: '25px', bottom: '78px' },
      to: [
        { scale: 0.8, left: '35px', bottom: '134px' },
        { scale: 2.3, left: '88px', bottom: '152px' },
        { scale: 1, left: '25px', bottom: '78px' },
      ],
    },
  },
  saturn: {
    m: {
      from: { left: '88px', bottom: '85px', rotateZ: 0 },
      to: [
        { left: '64px', bottom: '65px', rotateZ: 30 },
        { left: '104px', bottom: '50px', rotateZ: 30 },
        { left: '88px', bottom: '85px', rotateZ: 0 },
      ],
    },
    l: {
      from: { left: '132px', bottom: '125px', rotateZ: 0 },
      to: [
        { left: '100px', bottom: '100px', rotateZ: 30 },
        { left: '155px', bottom: '75px', rotateZ: 30 },
        { left: '132px', bottom: '125px', rotateZ: 0 },
      ],
    },
  },
} as const
